import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function UXUIDesign() {
  const projects = [{
    title: 'BioMaxing',
    category: 'Biohacking Platform',
    description: 'Multi-platform biohacking application spanning Web, Mobile and Telegram with comprehensive UX/UI design',
    image: 'https://storage.yandexcloud.net/maria-images/images/biomaxing_ready/homepage%204%20(1).png',
    color: 'from-cyan-100 to-teal-100',
    link: '/projects/biomaxing'
  }, {
    title: 'Co-Lab',
    category: 'Wellness Marketplace',
    description: 'Innovative beauty and wellness digital marketplace with immersive 3D experiences and gamified engagement',
    image: 'https://storage.yandexcloud.net/maria-images/images/co-lab_ready/Untitled%20design%20(3).png',
    color: 'from-cyan-100 to-stone-100',
    link: '/projects/co-lab'
  }, {
    title: 'ANM Website',
    category: 'Real Estate Management Company',
    description: 'Website re-design and user experience proposition for Aleksandro-Nevsky Manufacture',
    image: 'https://storage.yandexcloud.net/maria-images/images/anm_web_ready/anm%20select%20.png',
    color: 'from-emerald-100 to-teal-100',
    link: '/projects/anm-website'
  }];
  return <div className="w-full min-h-screen bg-stone-50" data-id="element-1702">
      {/* Header */}
      <header className="py-8 px-6 bg-white border-b border-stone-200" data-id="element-1703">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-1704">
          <Link to="/" className="inline-flex items-center gap-2 text-stone-600 hover:text-stone-900 transition-colors" data-id="element-1705">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-1706" />
            <span className="font-light" data-id="element-1707">Back to Home</span>
          </Link>
          <h1 className="text-2xl font-light text-stone-900" data-id="element-1708">Maria Elina</h1>
        </div>
      </header>
      {/* Hero Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-stone-50 via-emerald-50/30 to-stone-50" data-id="element-1709">
        <div className="max-w-7xl mx-auto text-center" data-id="element-1710">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-1711">
            <div className="text-6xl mb-6" data-id="element-1712">✨</div>
            <h2 className="text-5xl md:text-7xl font-light text-stone-900 mb-6" data-id="element-1713">
              UX/UI Design
            </h2>
            <p className="text-xl text-stone-600 font-light max-w-xl mx-auto" data-id="element-1714">
              Digital experiences that blend aesthetics with
              intuitive interaction
            </p>
          </motion.div>
        </div>
      </section>
      {/* Projects Grid */}
      <section className="py-20 px-6" data-id="element-1715">
        <div className="max-w-7xl mx-auto" data-id="element-1716">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1717">
            {projects.map((project, index) => <motion.div key={project.title} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} whileHover={{
            y: -10
          }} className="group cursor-pointer" data-id="element-1718">
                {project.link ? <Link to={project.link} data-id="element-1719">
                    <div className="relative overflow-hidden rounded-2xl mb-6 aspect-[4/3]" data-id="element-1720">
                      <motion.img src={project.image} alt={project.title} className="w-full h-full object-cover object-top" whileHover={{
                  scale: 1.05
                }} transition={{
                  duration: 0.6
                }} data-id="element-1721" />
                      <div className={`absolute inset-0 bg-gradient-to-br ${project.color} opacity-0 group-hover:opacity-40 transition-opacity duration-500`} data-id="element-1722" />
                    </div>
                    <div className="space-y-2" data-id="element-1723">
                      <p className="text-sm text-emerald-700 font-light tracking-wide uppercase" data-id="element-1724">
                        {project.category}
                      </p>
                      <h3 className="text-2xl font-light text-stone-900 group-hover:text-emerald-800 transition-colors" data-id="element-1725">
                        {project.title}
                      </h3>
                      <p className="text-stone-600 font-light leading-relaxed" data-id="element-1726">
                        {project.description}
                      </p>
                    </div>
                  </Link> : <>
                    <div className="relative overflow-hidden rounded-2xl mb-6 aspect-[4/3]" data-id="element-1727">
                      <motion.img src={project.image} alt={project.title} className="w-full h-full object-cover object-top" whileHover={{
                  scale: 1.05
                }} transition={{
                  duration: 0.6
                }} data-id="element-1728" />
                    </div>
                    <div className="space-y-2" data-id="element-1729">
                      <p className="text-sm text-emerald-700 font-light tracking-wide uppercase" data-id="element-1730">
                        {project.category}
                      </p>
                      <h3 className="text-2xl font-light text-stone-900" data-id="element-1731">
                        {project.title}
                      </h3>
                      <p className="text-stone-600 font-light leading-relaxed" data-id="element-1732">
                        {project.description}
                      </p>
                    </div>
                  </>}
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-t from-emerald-50/40 via-stone-50 to-stone-50 border-t border-emerald-600/30" data-id="element-1733">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1734">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-1735">
            <h2 className="text-4xl md:text-5xl font-light mb-6 text-stone-900" data-id="element-1736">
              Interested in collaborating?
            </h2>
            <p className="text-xl text-stone-600 font-light mb-8" data-id="element-1737">
              Let's create something meaningful together
            </p>
            <motion.a href="mailto:rassvet.hub@gmail.com" whileHover={{
            y: -3
          }} className="group inline-block relative" data-id="element-1738">
              {/* Outer border layer */}
              <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
              clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
            }} data-id="element-1739" />
              {/* Inner filled layer */}
              <div className="relative px-6 py-2 bg-emerald-600 text-white overflow-hidden mx-3 my-1.5" style={{
              clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
            }} data-id="element-1740">
                <div className="absolute inset-0 bg-emerald-700 translate-y-[100%] group-hover:translate-y-0 transition-transform duration-300" data-id="element-1741" />
                <span className="text-lg font-light relative z-10" data-id="element-1742">
                  Get in Touch
                </span>
              </div>
            </motion.a>
          </motion.div>
        </div>
      </section>
    </div>;
}